const IMPORT_TYPES = {
  CONTACT: 'contact',
  INSTITUTION: 'institution',
}

export default IMPORT_TYPES
